// extracted by mini-css-extract-plugin
export default {"container":"priceComparer-module__container__g9PbX","text":"priceComparer-module__text__FApQm","strikethrough":"priceComparer-module__strikethrough__LL-Pp"};